import { useRef } from 'react'
import { Box, Typography, Button } from '@mui/material'
import { ColStack } from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import { getLocalUser } from 'utils/localStorage'
import { getFullName } from 'utils/formatText'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'
import { ReactComponent as UserPhotoSvg } from 'assets/images/userPhoto.svg'
import AddIcon from '@mui/icons-material/Add'

const StepOneProfilePhoto = ({
  formik,
  profileImage,
  setProfileImage,
  answers
}) => {
  const { t } = useTranslation()
  const userInfo = getLocalUser()
  const imageInputRef = useRef(null)

  const uploadImage = e => {
    const file = e.target.files[0]
    if (file) {
      const url = URL.createObjectURL(file)
      setProfileImage(url)
      formik?.setFieldValue('profileImage', file)
    }
  }

  const handleUploadClick = () => {
    imageInputRef.current && imageInputRef.current.click()
  }

  return (
    <ColStack spacing={16}>
      <ColStack spacing={8}>
        <ColStack spacing={4}>
          <Typography variant='h2'>{t('onboarding.addPhoto')}</Typography>
          <Typography color='textSecondary'>
            {t('onboarding.faceToTheName')}
          </Typography>
        </ColStack>

        <RowStack spacing={12}>
          <input
            ref={imageInputRef}
            accept='image/*'
            hidden
            type='file'
            onChange={uploadImage}
          />
          <Box
            sx={[
              {
                width: 124,
                height: 124,
                borderRadius: 20,
                border: `2px solid ${colors.MidnightTeal300}`,
                backgroundColor: colors.MutedTeal50,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
              },
              profileImage && {
                backgroundImage: `url(${profileImage})`,
                backgroundSize: 'cover'
              }
            ]}>
            {!profileImage && <UserPhotoSvg />}

            <Button
              onClick={handleUploadClick}
              sx={{
                position: 'absolute',
                minWidth: 40,
                width: 40,
                height: 40,
                right: -2,
                bottom: -2
              }}>
              <AddIcon
                sx={{
                  fontSize: 30
                }}
              />
            </Button>
          </Box>

          <ColStack spacing={2} flex={1}>
            <Typography variant='h4'>{getFullName(userInfo)}</Typography>
            <Typography variant='body1KindaSmall' color='textSecondary'>
              {t('onboarding.experience')}: {answers[1]}
            </Typography>
            <Typography variant='body1KindaSmall' color='textSecondary'>
              {t('onboarding.seniority')}: {answers[0]}
            </Typography>
          </ColStack>
        </RowStack>

        <Typography variant='body1Micro' color='textSecondary'>
          {t('onboarding.recommendedSize')}
        </Typography>
      </ColStack>
    </ColStack>
  )
}

export default StepOneProfilePhoto
